import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Award, Download, Calendar } from 'lucide-react';
import { format } from 'date-fns';

interface Certificate {
  id: string;
  type: string;
  certificate_number: string;
  issue_date: string;
  status: string;
  metadata?: any;
}

interface CertificateCardProps {
  certificate: Certificate;
}

const CertificateCard: React.FC<CertificateCardProps> = ({ certificate }) => {
  const getCertificateTitle = (type: string) => {
    switch (type) {
      case 'foundation':
        return 'Foundation Certificate';
      case 'full_program':
        return 'Full Program Certificate';
      case 'capstone':
        return 'Capstone Certificate';
      default:
        return 'Certificate';
    }
  };

  const getCertificateDescription = (type: string) => {
    switch (type) {
      case 'foundation':
        return 'Completed Modules 1-4: AI Foundations';
      case 'full_program':
        return 'Completed all 16 modules and capstone project';
      case 'capstone':
        return 'Completed capstone project';
      default:
        return 'Certificate of completion';
    }
  };

  const handleDownload = () => {
    // TODO: Implement PDF download via edge function
    console.log('Download certificate:', certificate.id);
  };

  return (
    <Card className="border-primary/20">
      <CardHeader>
        <div className="flex items-start justify-between">
          <div className="flex items-center gap-3">
            <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center">
              <Award className="h-6 w-6 text-primary" />
            </div>
            <div>
              <CardTitle className="text-lg">{getCertificateTitle(certificate.type)}</CardTitle>
              <p className="text-sm text-muted-foreground mt-1">
                {getCertificateDescription(certificate.type)}
              </p>
            </div>
          </div>
          <Badge variant={certificate.status === 'issued' ? 'default' : 'secondary'}>
            {certificate.status}
          </Badge>
        </div>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between">
          <div className="space-y-1">
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Calendar className="h-4 w-4" />
              <span>Issued: {format(new Date(certificate.issue_date), 'MMM dd, yyyy')}</span>
            </div>
            <p className="text-xs text-muted-foreground">
              Certificate ID: {certificate.certificate_number}
            </p>
          </div>
          <Button size="sm" onClick={handleDownload}>
            <Download className="h-4 w-4 mr-2" />
            Download
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default CertificateCard;
